// API配置文件
export const API_CONFIG = {
  // 基础配置 - 可以通过修改这里来更改API域名
  BASE_URL: 'https://mlkapi.h3osistema.com',//'http://localhost:28083', //'https://mlkapi.snlvy.com',//'https://skapi.qinghe666.com',//
  TIMEOUT: 10000,
  
  // 请求头配置
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

// 环境配置
export const ENV_CONFIG = {
  development: {
    API_BASE_URL: 'https://mlkapi.h3osistema.com' //'http://localhost:28083' //
  },
  production: {
    API_BASE_URL: 'https://mlkapi.h3osistema.com' //'http://localhost:28083' //
  }
}

// 获取API基础URL的函数
export const getApiBaseUrl = () => {
  return API_CONFIG.BASE_URL
}

// 设置API基础URL的函数
export const setApiBaseUrl = (url) => {
  API_CONFIG.BASE_URL = url
}
